let BASE_URL = process.env.REACT_APP_BASE_URL;

if(process.env.NODE_ENV==="development") {
    BASE_URL = process.env.REACT_APP_DEV_URL
} 


export const REMEDY_LIST_URL = `${BASE_URL}/api/admin/remedy/request/list`; //GET
export const REMEDY_ADD_URL = `${BASE_URL}/api/admin/remedy/add`; //POST
export const remedyUrl = (id) => `${BASE_URL}/api/admin/remedy/${id}`; //GET
export const remedyEditUrl = (id) => `${BASE_URL}/api/admin/remedy/edit/${id}`; //POST

export const LOCATION_LIST_URL = `${BASE_URL}/api/location/list`; //GET
export const ALL_LOCATION_LIST_URL =   `${BASE_URL}/api/admin/location/request/list`; //GET

export const locationResourceListUrl = (loc) =>  `${BASE_URL}/api/admin/location/${loc}/request/list`; //GET
export const LOCATION_RESOURCE_ADD_URL = `${BASE_URL}/api/admin/location/add`; //POST
export const locationResourceEditUrl = (id) =>  `${BASE_URL}/api/admin/location/edit/${id}`; //POST
export const locationResourceUrl = (id) =>  `${BASE_URL}/api/admin/location/${id}`; //POST

export const KEY_RESOURCE_LIST_URL = `${BASE_URL}/api/admin/key-resources/request/list`; //GET
export const KEY_RESOURCE_ADD_URL = `${BASE_URL}/api/admin/key-resources/add`; //POST
export const keyResourceEditUrl = (id) =>  `${BASE_URL}/api/admin/key-resources/edit/${id}`; //POST
export const keyResourceUrl = (id) =>  `${BASE_URL}/api/admin/key-resources/${id}`; //POST
 

export const LOGIN_URL = `${BASE_URL}/api/auth/login`; //POST
export const GET_USER_URL = `${BASE_URL}/api/auth/user`; //GET
export const GET_USER_LIST_URL = `${BASE_URL}/api/auth/list/all`; //GET
export const ROOT_REGISTER_URL = `${BASE_URL}/api/auth/register/root`; //POST
export const REGISTER_URL = `${BASE_URL}/api/auth/register`; //POST
export const deleteUserUrl = (id) => `${BASE_URL}/api/auth/delete-user/${id}`; //GET